import * as requester from '../utils/requester';

export const fetchAllCafeEvents = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'GET',
        route: `v1/cafe-event?${query}`,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllArchivedCafeEvents = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'GET',
        route: `v1/cafe-event/archived?${query}`,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAllRequestedCafeEvents = query => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'GET',
        route: `v1/cafe-event/requested?${query}`,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchCafeEventDetailsById = id => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'GET',
        route: `v1/cafe-event/${id}`,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const addCafeEvent = event => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'POST',
        route: `v1/cafe-event`,
        data: event,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const updateCafeEvent = event => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'PUT',
        route: `v1/cafe-event`,
        data: event,
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const rejectEvent = (id, rejectionReason) => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'PUT',
        route: `v1/cafe-event/reject`,
        data: { id, rejectionReason },
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const disableEvent = id => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'PUT',
        route: `v1/cafe-event/disable`,
        data: { id },
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const confirmEvent = id => {
  return new Promise((resolve, reject) => {
    return requester
      .fetchAPI({
        method: 'PUT',
        route: `v1/cafe-event/confirm`,
        data: { id },
        withAuth: true
      })
      .then(res => {
        resolve(res.payload);
      })
      .catch(err => {
        reject(err);
      });
  });
};
